import { CustomerFile } from 'types/customer-files';

export const buildWazeURL = (customerFile: CustomerFile): string => {
  const querySting = encodeURI(
    `${customerFile.street_number} ${customerFile.street} ${customerFile.postal_code} ${customerFile.city}`
  );
  return `https://waze.com/ul?q=${querySting}`;
};
